import { ComponentProps } from 'react';
import './SecondaryNav.scss';
import { SecondaryNavItem } from 'app/agriculture/FarmMain/TopBar/components/SecondaryNav/SecondaryNavItem/SecondaryNavItem';
import { SecondaryNavSubNav } from 'app/agriculture/FarmMain/TopBar/components/SecondaryNav/SecondaryNavSubNav/SecondaryNavSubNav';

interface Item extends ComponentProps<typeof SecondaryNavItem> {
    subNavItems?: ComponentProps<typeof SecondaryNavSubNav>['items'];
}

interface SecondaryNavProps {
    items: Item[];
}

export function SecondaryNav({ items }: SecondaryNavProps) {
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="SecondaryNav">
            {items.map(({ subNavItems, ...secondaryNavItemProps }) => {
                return (
                    <SecondaryNavItem
                        key={secondaryNavItemProps.id}
                        {...secondaryNavItemProps}
                        subNavItems={subNavItems}
                    />
                );
            })}
        </div>
    );
}
